import React from "react";

const EconomicCalendar = ({ events }) => {
  return (
    <div className="bg-surface-default dark:bg-surface-default rounded-lg shadow p-6">
      <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">
        Economic Calendar
      </h2>
      <div className="space-y-4">
        {events && events.length > 0 ? (
          events.map((event, i) => (
            <div key={i} className="border-b border-gray-200 dark:border-gray-700 pb-4">
              <div className="flex justify-between items-center mb-2">
                <span className="font-medium text-gray-900 dark:text-gray-100">{event.time}</span>
                <span
                  className={`px-2 py-1 rounded text-xs ${
                    event.impact === "High"
                      ? "bg-red-100 text-red-800"
                      : event.impact === "Medium"
                        ? "bg-yellow-100 text-yellow-800"
                        : "bg-green-100 text-green-800"
                  }`}
                >
                  {event.impact} Impact
                </span>
              </div>
              <div className="text-sm text-gray-700 dark:text-gray-300">{event.event}</div>
              <div className="grid grid-cols-3 gap-2 mt-2 text-sm">
                <div>
                  <span className="text-gray-600 dark:text-gray-400">Actual: </span>
                  <span className="font-medium text-gray-900 dark:text-gray-100">
                    {event.actual}
                  </span>
                </div>
                <div>
                  <span className="text-gray-600 dark:text-gray-400">Forecast: </span>
                  <span className="font-medium text-gray-900 dark:text-gray-100">
                    {event.forecast}
                  </span>
                </div>
                <div>
                  <span className="text-gray-600 dark:text-gray-400">Previous: </span>
                  <span className="font-medium text-gray-900 dark:text-gray-100">
                    {event.previous}
                  </span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div>No events available.</div>
        )}
      </div>
    </div>
  );
};

export default EconomicCalendar;
